module.exports = __webpack_public_path__ + "./images/digital.jpg?cc2dc16b136237795dc79754cfb71d96";


//////////////////
// WEBPACK FOOTER
// ./src/assets/digital.jpg
// module id = 39
// module chunks = 0